import usePageTitle from "@/hooks/usePageTitle";
import TabLayout from "../_TabLayout";
import CoverageRoleTable from "../_components/CoverageRoleTable";
import { UPDATE_SECTION_PLAYER_ENGAGEMENT_CONSULTANT_MUTATION } from "../mutations";

export default function PlayerEngagementTabPage() {
  usePageTitle("/configuration/player-engagement", "Member 360 Configuration | Player Engagement");

  return (
    <TabLayout>
      <CoverageRoleTable
        kind="playerEngagement"
        personColumnHeader="Consultant"
        consultantTabLabel="By Consultant"
        searchPlaceholder="Search Sections"
        assignHeadline="Assign Player Engagement Consultant"
        staffLabel="Player Engagement Consultant"
        addPersonActionLabel="Add Consultant"
        clearHeadline="Clear Player Engagement Consultant"
        mutation={UPDATE_SECTION_PLAYER_ENGAGEMENT_CONSULTANT_MUTATION}
        tableTestId="player-engagement-table"
      />
    </TabLayout>
  );
}
